import { PermissionsList } from '@modules/permissions/constants';
import { Permission } from '@modules/permissions/utils';

export const ADMIN_TRANSLATION_MANAGER_ROUTE_NAME = Symbol('admin.translation.manager');
export const TRANSLATION_GROUP_TRANSLATE_MANAGER = Symbol('translate.manager');

export const BACKEND_TRANSLATIONS_URL = 'admin/translate_manager/server_marks';
export const SAVE_TRANSLATION_URL = 'admin/translate_manager/save';
export const EXPORT_TRANSLATIONS_URL = 'admin/translate_manager/export';
export const IMPORT_TRANSLATIONS_URL = 'admin/translate_manager/import';

export const TRANSLATE_MANAGER_BACKEND_TRANSLATIONS_QUERY_KEY = 'translate-manager.backend-translations';
export const TRANSLATE_MANAGER_SAVE_TRANSLATION_MUTATION_KEY = 'translate-manager.save-key';
export const TRANSLATE_MANAGER_IMPORT_TRANSLATIONS_MUTATION_KEY = 'translate-manager.import';

export const YML_INDENT = '  '; // 2 spaces

export const TRANSLATE_MANAGER_PERMISSIONS = {
  TRANSLATEMANAGER_EDIT: new Permission(PermissionsList.admin.TRANSLATEMANAGER_EDIT),
};
